export default class CompanyUser {
    constructor(data = {}) {
        this.company_name = data.company_name;
        this.email = data.email;
        this.admin_name = data.admin_name;
        this.company_type = data.company_type;
        this.service_type = data.service_type || [];
        this.is_multimode = data.is_multimode || false;
        this.is_warehouse = data.is_warehouse || false;
        this.is_exim = data.is_exim || false;
        this.modeOfTransport = data.modeOfTransport || [];
        this.master_type = data.master_type;
        this.is_active = data.is_active || false;
        this.is_admin = data.is_admin || false;
        this.created = data.created;
        this.company_logo = data.company_logo;
        this.id = data.id;
        this.company_id = data.company_id;
        this.user_id = data.user_id;
        this.bank_account_no = data.bank_account_no;
        this.bank_ifsc_code = data.bank_ifsc_code;
        this.bank_name = data.bank_name;
        this.business_segment = data.business_segment;
        this.cin_no = data.cin_no;
        this.company_address = data.company_address;
        this.company_email = data.company_email;
        this.company_website = data.company_website;
        this.fssai_certificate_number = data.fssai_certificate_number;
        this.fssai_validity_date = data.fssai_validity_date;
        this.group_company = data.group_company || [];
        this.gst_mechanism = data.gst_mechanism;
        this.gst_mechanism_id = data.gst_mechanism_id;
        this.gstin = data.gstin;
        this.incorporation_date = data.incorporation_date;
        this.is_blocked = data.is_blocked || false;
        this.is_e_invoice_enabled = data.is_e_invoice_enabled || false;
        this.is_google_enabled = data.is_google_enabled || false;
        this.is_gst_applicable = data.is_gst_applicable || false;
        this.is_sqs_close_indent = data.is_sqs_close_indent || false;
        this.last_fiscal_turnover = data.last_fiscal_turnover || {};
        this.materialTaxRate = data.materialTaxRate || [];
        this.msa_validity_date = data.msa_validity_date;
        this.sap_carrier_code = data.sap_carrier_code;
        this.sap_vendor_code = data.sap_vendor_code;
        this.state = data.state;
        this.state_code = data.state_code;
        this.tax_no = data.tax_no;
        this.year_of_formation = data.year_of_formation;
        this.zipcode = data.zipcode;
        this.dph_enable_day = data.dph_enable_day;
        this.dph_enabled = data.dph_enabled || false;
        this.enable_action_config = data.enable_action_config || false;
        this.user_type = data.user_type;
        this.disable_menus = data.disable_menus || [];
        this.token = data.token;
        this.is_sso_login = data.is_sso_login || false;
        this.name = data.name;
        this.isCP = data.isCP || false;
        this.company_text_id = data.company_text_id;
        // this.Contracting = data.Contracting || false;
        // this.Indenting = data.Indenting || false;
        // this["Tracking/VIMS"] = data["Tracking/VIMS"] || false;
        // this.Accounts = data.Accounts || false;
        // this.Reports = data.Reports || false;
        // this.Admin = data.Admin || false;
        this.modules_access_list = data.modules_access_list || [];
        this.manual_enabled = data.manual_enabled || false;
        // this.menus_to_hide = data.menus_to_hide || [];
        // this.tabs_to_hide = data.tabs_to_hide || [];
        // this.reports_to_hide = data.reports_to_hide || [];
        // this.vivo_dashboard_hide = data.vivo_dashboard_hide || [];
        this.transit_dashboard_hide = data.transit_dashboard_hide || [];
        this.audit_dashboard_hide = data.audit_dashboard_hide || [];
        this.fields_to_display = data.fields_to_display || [];
        this.bound = data.bound || {};
        this.transit_dashboard_type = data.transit_dashboard_type;
        this.mandatory_vehicle_report_time = data.mandatory_vehicle_report_time;
        this.consignee_location_search = data.consignee_location_search || false;
        this.auto_populate_from_location = data.auto_populate_from_location || false;
        this.audit_custom_invoice = data.audit_custom_invoice || false;
        this.hide_reporting_tab_transporters = data.hide_reporting_tab_transporters || false;
        this.add_vehicle_free_text = data.add_vehicle_free_text || false;
        this.upload_rates = data.upload_rates || false;
        this.send_data_to_novire = data.send_data_to_novire || false;
        this.show_round_trip = data.show_round_trip || false;
        this.mail_enabled = data.mail_enabled || false;
        this.feedback_visible = data.feedback_visible || false;
        this.branch_as_consignees = data.branch_as_consignees || false;
        this.hide_vivo_tabs = data.hide_vivo_tabs || false;
        this.show_lr = data.show_lr || false;
        this.temp_menus_data = data.temp_menus_data || [];
        this.temp_menus_display = data.temp_menus_display || [];
        this.token_at_placement = data.token_at_placement || false;
        this.manual_enabled_branches = data.manual_enabled_branches || [];
        this.show_tracking = data.show_tracking || false;
        this.product_checklist = data.product_checklist || false;
        this.updated = data.updated;
        this.is_show_dph_details = data.is_show_dph_details || false;
        this.is_sent_bid_details_dph = data.is_sent_bid_details_dph || false;
        this.indent_types = data.indent_types || [];
        this.has_subplant = data.has_subplant || false;
        this.vivo_detail_log_enabled = data.vivo_detail_log_enabled || false;
        this.edit_vehicle_at_multiple_moves = data.edit_vehicle_at_multiple_moves || [];
        this.push_to_accounts_at_source_close_indent = data.push_to_accounts_at_source_close_indent || false;
        this.push_to_accounts_at_source_gate_out = data.push_to_accounts_at_source_gate_out || false;
        this.is_vims_trip_create = data.is_vims_trip_create || false;
        this.enable_close_indent_dashboard = data.enable_close_indent_dashboard || false;
        this.company_tk11_enabled = data.company_tk11_enabled || false;
        this.is_new_rfq_enabled = data.is_new_rfq_enabled || false;
        this.is_sap_master_log_enabled = data.is_sap_master_log_enabled || false;
        this.is_auto_accept = data.is_auto_accept || false;
        this.is_approver = data.is_approver || false;
        this.is_planner = data.is_planner || false;
        this.is_visible = data.is_visible || false;
        this.isCreateMasterData = data.isCreateMasterData || false;
        this.is_accounts_bill_processor = data.is_accounts_bill_processor || false;
        this.isEditContractTenure = data.isEditContractTenure || false;
        this.isDphApprover = data.isDphApprover || false;
        this.isSpotContract = data.isSpotContract || false;
        this.edit_bidding_time = data.edit_bidding_time || false;
        this.ammendment_app_level = data.ammendment_app_level;
        this.is_auto_move_enabled = data.is_auto_move_enabled || false;
        this.auto_moves_id = data.auto_moves_id || [];
        this.auto_moves = data.auto_moves || "";
        this.branchesList = data.branchesList || [];
        this.branchesListLatest = data.branchesListLatest || [];
        this.cargo_planner = data.cargo_planner || false;
        this.has_vehicle_approval = data.has_vehicle_approval || false;
        this.is_vehicle_approver = data.is_vehicle_approver || false;
        this.vehicle_master_access = data.vehicle_master_access || false;
        this.weigh_bridge = data.weigh_bridge || {};
        this.branch_id = data.branch_id;
        this.branch_name = data.branch_name;
        this.rfq_types = data.rfq_types || [];
        this.is_cp_form = data.is_cp_form || false;
        this.isTk11 = data.isTk11 || false;
        this.is_disposal_access = data.is_disposal_access || false;
        this.image_url = data.image_url;
        this.payment_pending = data.payment_pending || false;
        this.created_on = data.created_on;
        this.device_type = data.device_type;
        this.module_id = data.module_id;
    }
}
